/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Game from '../Game/Game';
import { ClientEvent } from '../Game/Integrations/ClientEvent';
import RecoveryManager from '../Game/RecoveryManager';
import Communicator from '../Server/Communicator';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Effect that blocks execution until button pressed. */
@cc._decorator.ccclass
export default class ButtonEffect extends Effect
{
    /** The corresponding button's node. */
    @property({ type: cc.Node, visible: true })
    private _button: cc.Node = null;

    @property()
    protected enableGameAdvancePlay: boolean = true;

    /** @hidden */
    private _recoveryManagerRef: InjectableComponent<RecoveryManager> = new InjectableComponent<RecoveryManager>();

    /** @hidden */
    private _gameRef: InjectableComponent<Game> = new InjectableComponent<Game>();

    /** @hidden */
    private _communicatorRef: InjectableComponent<Communicator> = new InjectableComponent();

    /** @hidden */
    protected setContexts(): void
    {
        this._recoveryManagerRef.SetContext(RecoveryManager);
        this._gameRef.SetContext(Game);
        this._communicatorRef.SetContext(Communicator);
    }

    /** Executes the effect. */
    protected trigger = (): void =>
    {
        if ((this._recoveryManagerRef.Value.Recovering
            && !this._recoveryManagerRef.Value.AtLatestPlay) || this.isStopping)
        {
            this.onClick();
        }
        else
        {
            this._button.once(cc.Node.EventType.TOUCH_END, this.onClick, this);
            if (this.enableGameAdvancePlay)
            {
                this._gameRef.Value.AdvancePlayEventDispatcher.once(Game.AdvancePlayEventName, this.onClick, this);
            }

            this._communicatorRef.Value.ReportClientEvent(ClientEvent.USER_INPUT_PROMPT);
        }
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (this._button) { this._button.off(cc.Node.EventType.TOUCH_END, this.onClick, this); }
        this._gameRef.WithValue(game =>
            {
                game.AdvancePlayEventDispatcher.off(Game.AdvancePlayEventName, this.onClick, this);
            });
    }

    /** @hidden */
    private onClick(): void
    {
        if (this.IsCurrentState())
        {
            this.complete();
            this.isStopping = false;

            this.onDestroy();
        }
    }

    /** Stops the in-progress effect or prevents its next execution. */
    public Stop(): void
    {
        super.Stop();

        if (this.IsCurrentState())
        {
            this.onClick();
        }
    }
}
